// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/settings/settings.less
// module id = 4063
// module chunks = 0